export default "__VITE_ASSET__BfmCkAaM__"